var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('van-list',{attrs:{"finished":_vm.finished,"finished-text":_vm.finishedText,"immediate-check":_vm.immediateCheck,"offset":_vm.offset},on:{"load":_vm.onLoad},model:{value:(_vm.loading),callback:function ($$v) {_vm.loading=$$v},expression:"loading"}},[_vm._t("default")],2),_c('go-top',{attrs:{"round":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }